
import HeaderDashboard from '../../components/HeaderDashboard';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';
import ArticleIcon from '@mui/icons-material/Article';
import { useNavigate } from 'react-router-dom';
import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Divider,
    IconButton,
    LinearProgress,
    Menu,
    MenuItem,
    TextField,
    Tooltip,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import AdicionarSocioModal from './AdicionarSocioModal';
import VisualizarSocioModal from './VisualizarSocioModal';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const PURPLE = "#9C01B9";
const GREEN = "#087F3F";
const BLUE = "#2864E8";
const TEXT = "#171717";
const MUTED = "#667085";
const BORDER = "#E7E9ED";

const COLORS = [PURPLE, GREEN, BLUE];


const NewFichaCadastral = () => {
    const navigate = useNavigate();

    const [capitalSocial, setCapitalSocial] = useState(0);

    const [alteracoes, setAlteracoes] = useState(false);

    const [adicionarSocioModalOpen, setAdicionarSocioModalOpen] = useState(false);
    const [sociosFicha, setSociosFicha] = useState([]);
    const [socioEdicao, setSocioEdicao] = useState(null);

    const abrirModalSocio = (socio = null) => {
        setSocioEdicao(socio);
        setAdicionarSocioModalOpen(true);
    };

    const fecharModalSocio = () => {
        setAdicionarSocioModalOpen(false);
        setSocioEdicao(null);
    };

    const [socioVisualizacao, setSocioVisualizacao] = useState(null);

    const [carregando, setCarregando] = useState(true);
    const [carregouFicha, setCarregouFicha] = useState(false);
    const [salvandoDistribuicao, setSalvandoDistribuicao] = useState(false);

    useEffect(() => {
        const getFichaCadastral = async () => {
            setCarregando(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/get/fichaCadastral`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": localStorage.getItem("token"),
                    },
                });
                const data = response.data;
                console.log("Ficha cadastral data:", data);
                setCapitalSocial(Number(data.fichas?.[0]?.capitalSocial) || 0);
                let addCores = (data.fichas || []).map((socio, index) => {
                    return {
                        ...socio,
                        cor: COLORS[index % COLORS.length], // ou qualquer lógica para definir a cor
                    };
                });
                setSociosFicha(addCores || []);
            } catch (error) {
                console.error("Erro ao buscar ficha cadastral:", error);
            } finally {
                setCarregando(false);
                setCarregouFicha(true);
            }
        };
        getFichaCadastral();
    }, [adicionarSocioModalOpen]);

    const totalPercentual = useMemo(
        () =>
            sociosFicha.reduce(
                (total, socio) => total + Number(socio.percentual || 0),
                0
            ),
        [sociosFicha]
    );

    const totalQuotas = capitalSocial;

    const formatCurrency = (value) =>
        Number(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });


    const salvarDistribuicao = async () => {
        setSalvandoDistribuicao(true);
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/atualizarPercentual/fichaCadastral`, sociosFicha, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token"),
                },
            });
            console.log("Distribuição salva com sucesso:", response.data);
        } catch (error) {
            console.error("Erro ao salvar distribuição:", error);
        } finally {
            setSalvandoDistribuicao(false);
        }
        setAlteracoes(false);
    };

    return (
        <>
            <HeaderDashboard />
            <div style={{ marginTop: "60px", padding: "20px", minHeight: "100vh", marginBottom: "50px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                    <div style={{ width: "80%" }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                color="inherit"
                                onClick={() => navigate("../dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography
                                sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                            >
                                <ArticleIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Ficha Cadastral
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <Box
                    sx={{
                        width: window.innerWidth > 768 ? "80%" : "100%",
                        minHeight: "100vh",
                        // backgroundColor: BACKGROUND,
                        boxSizing: "border-box",
                        margin: "20px auto",
                    }}
                >
                    {!carregouFicha ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1.5,
                                py: 10,
                            }}
                        >
                            <CircularProgress sx={{ color: PURPLE }} />
                            <Typography sx={{ fontSize: 13, color: MUTED }}>
                                Carregando ficha cadastral...
                            </Typography>
                        </Box>
                    ) : (
                    <>
                    {carregando && (
                        <LinearProgress
                            sx={{
                                mb: 2,
                                borderRadius: "4px",
                                backgroundColor: "#F6E9F9",
                                "& .MuiLinearProgress-bar": {
                                    backgroundColor: PURPLE,
                                },
                            }}
                        />
                    )}

                    {/* HEADER */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: {
                                xs: "flex-start",
                                sm: "center",
                            },
                            justifyContent: "space-between",
                            gap: 2,
                            mb: 3,
                            flexDirection: {
                                xs: "column",
                                sm: "row",
                            },
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    flexWrap: "wrap",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: {
                                            xs: 21,
                                            sm: 23,
                                        },
                                        fontWeight: 700,
                                        color: TEXT,
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Sócios da empresa
                                </Typography>

                                <Chip
                                    icon={
                                        <CheckCircleOutlineIcon
                                            sx={{ fontSize: 13 }}
                                        />
                                    }
                                    label="Contrato Social Vigente"
                                    size="small"
                                    sx={{
                                        height: 22,
                                        borderRadius: "12px",
                                        backgroundColor: "#E9F9F1",
                                        color: GREEN,
                                        fontSize: 10,
                                        fontWeight: 600,
                                        "& .MuiChip-icon": {
                                            color: GREEN,
                                        },
                                    }}
                                />
                            </Box>

                            <Typography
                                sx={{
                                    mt: 0.5,
                                    color: MUTED,
                                    fontSize: 13,
                                }}
                            >
                                Cadastre os sócios e defina a participação societária
                                oficial na empresa.
                            </Typography>
                        </Box>

                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            sx={{
                                flexShrink: 0,
                                minHeight: 40,
                                px: 2,
                                borderRadius: "9px",
                                backgroundColor: PURPLE,
                                textTransform: "none",
                                fontSize: 13,
                                fontWeight: 700,
                                boxShadow: "0 3px 8px rgba(156, 1, 185, 0.20)",
                                "&:hover": {
                                    backgroundColor: "#85009E",
                                },
                            }}
                            onClick={() => abrirModalSocio()}
                        >
                            Adicionar sócio
                        </Button>
                    </Box>

                    {/* PARTICIPAÇÃO SOCIETÁRIA */}
                    <Box
                        sx={{
                            backgroundColor: "#FFF",
                            border: `1px solid ${BORDER}`,
                            borderRadius: "12px",
                            p: {
                                xs: 2,
                                sm: 2.5,
                            },
                            mb: 3,
                            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.02)",
                        }}
                    >
                        {/* TÍTULO */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: {
                                    xs: "flex-start",
                                    sm: "center",
                                },
                                justifyContent: "space-between",
                                gap: 2,
                                flexWrap: "wrap",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.5,
                                }}
                            >
                                {/* <Box
                                    sx={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: "8px",
                                        backgroundColor: "#F6E9F9",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    }}
                                >
                                    <AccountBalanceOutlinedIcon
                                        sx={{
                                            color: PURPLE,
                                            fontSize: 18,
                                        }}
                                    />
                                </Box> */}

                                <Box>
                                    <Typography
                                        sx={{
                                            fontSize: 17,
                                            fontWeight: 700,
                                            color: TEXT,
                                        }}
                                    >
                                        Participação societária
                                    </Typography>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 2,
                                            mt: 2,
                                            px: 1.5,
                                            py: 1.2,
                                            border: "1px solid #E4E7EC",
                                            borderRadius: "10px",
                                            backgroundColor: "#FAFAFA",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {/* Informações */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1.2,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 32,
                                                    height: 32,
                                                    borderRadius: "8px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: "#F0E6F3",
                                                    color: "#9C01B9",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <AttachMoneyIcon
                                                    sx={{
                                                        fontSize: 18,
                                                    }}
                                                />
                                            </Box>

                                            <Box>
                                                <Typography
                                                    sx={{
                                                        fontSize: 11,
                                                        color: MUTED,
                                                        lineHeight: 1.2,
                                                        mb: 0.3,
                                                    }}
                                                >
                                                    Capital Social Total
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: 13,
                                                        fontWeight: 500,
                                                        lineHeight: 1.2,
                                                    }}
                                                >
                                                    {formatCurrency(capitalSocial)}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        {/* Indicador */}
                                        <Typography
                                            sx={{
                                                fontSize: 11,
                                                color: MUTED,
                                                fontWeight: 500,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Valor total do capital da empresa
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            <Chip
                                icon={
                                    <CheckCircleOutlineIcon
                                        sx={{ fontSize: 14 }}
                                    />
                                }
                                label={`${totalPercentual}% distribuído • ${totalPercentual === 100
                                    ? "Regular"
                                    : "Verificar"
                                    }`}
                                size="small"
                                sx={{
                                    height: 25,
                                    borderRadius: "14px",
                                    backgroundColor:
                                        totalPercentual === 100
                                            ? "#D9FBE9"
                                            : "#FFF1D6",
                                    color:
                                        totalPercentual === 100
                                            ? GREEN
                                            : "#A15C00",
                                    fontSize: 10,
                                    fontWeight: 700,
                                    "& .MuiChip-icon": {
                                        color:
                                            totalPercentual === 100
                                                ? GREEN
                                                : "#A15C00",
                                    },
                                }}
                            />
                        </Box>

                        {/* BARRA */}
                        <Box
                            sx={{
                                width: "100%",
                                height: 11,
                                backgroundColor: "#E9EDF2",
                                borderRadius: "8px",
                                overflow: "hidden",
                                mt: 2,
                                display: "flex",
                            }}
                        >
                            {sociosFicha.map((socio) => (
                                <Box
                                    key={socio.id}
                                    sx={{
                                        width: `${socio.percentual}%`,
                                        height: "100%",
                                        backgroundColor: socio.cor,
                                        transition: "width .25s ease",
                                    }}
                                />
                            ))}
                        </Box>

                        {/* MINI CARDS DOS SÓCIOS */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                mt: 2.5,
                                flexWrap: "wrap",
                            }}
                        >
                            {sociosFicha.map((socio) => (
                                <Box
                                    key={socio.id}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        backgroundColor: "#F3F5F7",
                                        borderRadius: "9px",
                                        px: 1.3,
                                        py: 1,
                                        minWidth: {
                                            xs: "100%",
                                            sm: 155,
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            backgroundColor: socio.cor,
                                            flexShrink: 0,
                                        }}
                                    />

                                    <Box>
                                        <Typography
                                            sx={{
                                                fontSize: 12,
                                                fontWeight: 700,
                                                color: TEXT,
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {socio.nome}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: 11,
                                                color: MUTED,
                                                mt: 0.2,
                                            }}
                                        >
                                            {Number(socio.percentual).toFixed(2)}% •{" "}
                                            {formatCurrency(
                                                (capitalSocial *
                                                    socio.percentual) /
                                                100
                                            )}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        {/* FOOTER DISTRIBUIÇÃO */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 2,
                                mt: 2.5,
                                flexWrap: "wrap",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.7,
                                }}
                            >
                                <InfoOutlinedIcon
                                    sx={{
                                        fontSize: 15,
                                        color: "#52708A",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        fontSize: 11,
                                        color: MUTED,
                                    }}
                                >
                                    Edite as porcentagens diretamente nos cards abaixo
                                    para recalcular.
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                }}
                            >
                                <Button
                                    startIcon={
                                        salvandoDistribuicao ? (
                                            <CircularProgress size={14} sx={{ color: "inherit" }} />
                                        ) : (
                                            <SaveOutlinedIcon />
                                        )
                                    }
                                    disabled={
                                        !alteracoes ||
                                        totalPercentual !== 100 ||
                                        salvandoDistribuicao
                                    }
                                    onClick={salvarDistribuicao}
                                    variant="contained"
                                    sx={{
                                        minHeight: 30,
                                        px: 1.5,
                                        borderRadius: "9px",
                                        backgroundColor: GREEN,
                                        color: "#FFF",
                                        textTransform: "none",
                                        fontSize: 12,
                                        fontWeight: 700,
                                        "&:hover": {
                                            backgroundColor: "#066B35",
                                        },
                                    }}
                                >
                                    {salvandoDistribuicao
                                        ? "Salvando..."
                                        : "Salvar Distribuição"}
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    {/* TÍTULO SÓCIOS */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            mb: 1.5,
                            gap: 2,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 15,
                                    fontWeight: 700,
                                    color: TEXT,
                                }}
                            >
                                Sócios Atuais
                            </Typography>

                            <Chip
                                label={`${sociosFicha.length} Sócios`}
                                size="small"
                                sx={{
                                    height: 19,
                                    borderRadius: "10px",
                                    backgroundColor: "#EEF0F3",
                                    color: MUTED,
                                    fontSize: 9,
                                    fontWeight: 600,
                                }}
                            />
                        </Box>

                        <Typography
                            sx={{
                                fontSize: 9,
                                color: MUTED,
                                display: {
                                    xs: "none",
                                    sm: "block",
                                },
                            }}
                        >
                            Registrados na Junta Comercial
                        </Typography>
                    </Box>

                    {/* LISTA DE SÓCIOS */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                        }}
                    >
                        {sociosFicha.map((socio) => (
                            <SocioCard
                                key={socio.id}
                                socio={socio}
                                capitalSocial={capitalSocial}
                                setSociosFicha={setSociosFicha}
                                formatCurrency={formatCurrency}
                                setAlteracoes={setAlteracoes}
                                onEditar={() => abrirModalSocio(socio)}
                                onVisualizar={() => setSocioVisualizacao(socio)}
                            />
                        ))}
                    </Box>
                    </>
                    )}
                </Box>
            </div>
            <AdicionarSocioModal
                open={adicionarSocioModalOpen}
                onClose={fecharModalSocio}
                onSave={fecharModalSocio}
                socio={socioEdicao}
            />
            <VisualizarSocioModal
                open={Boolean(socioVisualizacao)}
                onClose={() => setSocioVisualizacao(null)}
                onEditar={() => {
                    abrirModalSocio(socioVisualizacao);
                    setSocioVisualizacao(null);
                }}
                socio={socioVisualizacao}
            />
        </>
    );
};

function SocioCard({
    socio,
    capitalSocial,
    setSociosFicha,
    formatCurrency,
    setAlteracoes,
    onEditar,
    onVisualizar,
}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const valorParticipacao =
        (capitalSocial * Number(socio.percentual || 0)) / 100;

    return (
        <Box
            sx={{
                backgroundColor: "#FFF",
                border: `1px solid ${BORDER}`,
                borderRadius: "12px",
                px: {
                    xs: 1.5,
                    sm: 2,
                },
                py: {
                    xs: 1.5,
                    sm: 1.8,
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                flexWrap: {
                    xs: "wrap",
                    md: "nowrap",
                },
                boxShadow: "0 1px 2px rgba(16, 24, 40, 0.02)",
            }}
        >
            {/* IDENTIFICAÇÃO */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    flex: 1,
                    minWidth: 0,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: "11px",
                        backgroundColor: socio.cor,
                        color: "#FFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                        fontSize: 13,
                        flexShrink: 0,
                    }}
                >
                    {socio.nome.split(" ").map((n) => n[0].toUpperCase()).join("")}
                </Box>
                <Box
                    sx={{
                        minWidth: 0,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.7,
                            flexWrap: "wrap",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 14,
                                fontWeight: 700,
                                color: TEXT,
                                textTransform: "none",
                            }}
                        >
                            {socio.nome}
                        </Typography>

                        <Chip
                            label="Sócio"
                            size="small"
                            sx={{
                                height: 18,
                                borderRadius: "8px",
                                backgroundColor: "#F1F3F5",
                                color: "#5E6673",
                                fontSize: 10,
                                fontWeight: 500,
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mt: 0.5,
                            flexWrap: "wrap",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 11,
                                color: MUTED,
                            }}
                        >
                            <b>CPF:</b> {socio.cpf}
                        </Typography>

                        <Typography
                            sx={{
                                color: "#AAB0B8",
                                fontSize: 11,
                            }}
                        >
                            •
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: 12,
                                color: MUTED,
                            }}
                        >
                            Entrada: {new Date(socio.createdAt).toLocaleDateString()}
                        </Typography>

                        <Typography
                            sx={{
                                color: "#AAB0B8",
                                fontSize: 11,
                            }}
                        >
                            •
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: 12,
                                color: MUTED,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: {
                                    xs: 180,
                                    md: "none",
                                },
                            }}
                        >
                            {socio.email}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* PARTICIPAÇÃO */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    flexShrink: 0,
                    width: {
                        xs: "100%",
                        md: "auto",
                    },
                    justifyContent: {
                        xs: "space-between",
                        md: "flex-start",
                    },
                    pl: {
                        xs: 0,
                        md: 2,
                    },
                }}
            >
                <Box
                    sx={{
                        textAlign: "right",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 10,
                            color: MUTED,
                            mb: 0.3,
                        }}
                    >
                        Participação Societária
                    </Typography>

                    <TextField
                        value={socio.percentual}
                        onChange={(e) => {
                            setSociosFicha((prev) =>
                                prev.map((s) =>
                                    s.cpf === socio.cpf
                                        ? { ...s, percentual: e.target.value.replace(",", ".") }
                                        : s
                                )
                            )
                            setAlteracoes(true);
                        }}
                        size="small"
                        inputProps={{
                            min: 0,
                            max: 100,
                            step: 0.01,
                        }}
                        sx={{
                            width: 90,
                            "& .MuiOutlinedInput-root": {
                                height: 27,
                                borderRadius: "7px",
                                backgroundColor: "#F0F2F4",
                                fontSize: 11,
                                fontWeight: 700,
                            },
                            "& .MuiOutlinedInput-input": {
                                textAlign: "right",
                                py: 0,
                                px: 1,
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <Typography
                                    sx={{
                                        fontSize: 10,
                                        color: MUTED,
                                    }}
                                >
                                    %
                                </Typography>
                            ),
                        }}
                    />

                    <Typography
                        sx={{
                            fontSize: 10,
                            color: MUTED,
                            mt: 0.4,
                        }}
                    >
                        valor ({formatCurrency(valorParticipacao)})
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    startIcon={<EditIcon sx={{ fontSize: 13 }} />}
                    sx={{
                        minWidth: 68,
                        height: 29,
                        px: 1.2,
                        borderRadius: "8px",
                        backgroundColor: "#ECEFF2",
                        color: TEXT,
                        boxShadow: "none",
                        textTransform: "none",
                        fontSize: 11,
                        fontWeight: 600,
                        "&:hover": {
                            backgroundColor: "#E1E4E8",
                            boxShadow: "none",
                        },
                    }}
                    onClick={onEditar}
                >
                    Editar
                </Button>

                <Tooltip title="Mais opções">
                    <IconButton
                        size="small"
                        onClick={(event) =>
                            setAnchorEl(event.currentTarget)
                        }
                        sx={{
                            color: "#475467",
                        }}
                    >
                        <MoreVertIcon sx={{ fontSize: 19 }} />
                    </IconButton>
                </Tooltip>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                >
                    <MenuItem
                        sx={{ fontSize: 13 }}
                        onClick={() => {
                            setAnchorEl(null);
                            onEditar();
                        }}
                    >
                        Editar sócio
                    </MenuItem>

                    <MenuItem
                        sx={{ fontSize: 13 }}
                        onClick={() => {
                            setAnchorEl(null);
                            onVisualizar();
                        }}
                    >
                        Visualizar dados
                    </MenuItem>

                    {/* <MenuItem
                        sx={{
                            fontSize: 13,
                            color: "#D32F2F",
                        }}
                        onClick={() => setAnchorEl(null)}
                    >
                        Remover sócio
                    </MenuItem> */}
                </Menu>
            </Box>
        </Box>
    );
}

export default NewFichaCadastral;